module.exports = __webpack_public_path__ + "img/placeholder-image-banner.b991a7ad.svg";